"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeHmac = computeHmac;
exports.ripemd160 = ripemd160;
exports.sha256 = sha256;
exports.sha512 = sha512;

var _hash = _interopRequireDefault(require("hash.js"));

var _bytes = require("@ethersproject/bytes");

var _types = require("./types");

var _logger = require("@ethersproject/logger");

var _version = require("./_version");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const _ripemd160 = _hash.ripemd160;
const logger = new _logger.Logger(_version.version);

function ripemd160(data) {
  return "0x" + _hash.default.ripemd160().update((0, _bytes.arrayify)(data)).digest("hex");
}

function sha256(data) {
  return "0x" + _hash.default.sha256().update((0, _bytes.arrayify)(data)).digest("hex");
}

function sha512(data) {
  return "0x" + _hash.default.sha512().update((0, _bytes.arrayify)(data)).digest("hex");
}

function computeHmac(algorithm, key, data) {
  if (!_types.SupportedAlgorithm[algorithm]) {
    logger.throwError("unsupported algorithm " + algorithm, _logger.Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "hmac",
      algorithm: algorithm
    });
  }

  return "0x" + _hash.default.hmac(_hash.default[algorithm], (0, _bytes.arrayify)(key)).update((0, _bytes.arrayify)(data)).digest("hex");
}